export default {
  methods: {
    getDateISO(date) {
      return (date instanceof Date) ? date.toISOString().substring(0, 10) : null;
    },
  },
};
